export default __webpack_public_path__ + "static/media/img-36-velho.3b7447e2.jpg";